import {useDispatch} from 'react-redux';
import {showDetailedSnackbar, showSnackbar} from '../../AppLayout/ApplicationSlice';

const useNotification = () => {
    const dispatch = useDispatch();
    const defaults = {
        successMessage: 'Operation completed successfully',
        errorMessage: 'Operation failed'
    };

    const showErrorNotification = (message = defaults.errorMessage) =>
        dispatch(showSnackbar({
            message,
            severity: 'error'
        }));

    const showSuccessNotification = (message = defaults.successMessage) =>
        dispatch(showSnackbar({
            message,
            severity: 'success'
        }));

    const showDetailedErrorNotification = (message = defaults.errorMessage, errors) =>
        dispatch(showDetailedSnackbar({
            severity: 'error',
            title: message,
            messages: errors?.map(e => e.errorMessage)
        }));

    const showInfoNotification = (message) =>
        dispatch(showSnackbar({
            message,
            severity: 'info'
        }));

    return {showErrorNotification, showSuccessNotification, showDetailedErrorNotification, showInfoNotification};
};

export default useNotification;